import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';

export const IconButton = ({ className, name, onClick, style }) => {
  const snapmongo = name === 'snapmongo';
  return (
    <div onClick={onClick}
      className={className}
      style={Object.assign({
        cursor: 'pointer',
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0.5px 0.5px 3px',
      }, style)}>
      <FontAwesome name={snapmongo ? 'cloud' : name} style={{
        width: '20px',
        height: '20px',
        fontSize: '20px',
        lineHeight: '20px',
        margin: '10px',
      }}/>
      {snapmongo &&
        <FontAwesome name="flash" style={{
          color: 'white',
          width: '20px',
          height: '20px',
          fontSize: '9px',
          lineHeight: '20px',
          margin: '-30px 10px 10px',
        }}/>}
    </div>
  );
};

IconButton.propTypes = {
  name: PropTypes.string,
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/common/iconButton.js